import { useLocation, useNavigate } from "react-router-dom";

import { Box, Flex, Label } from "../../../style";
import { colors } from "../../../variables";

export const NavbarItem = ({ children, to }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const formattedChildren = children.toLowerCase();

  const selected = pathname.includes(formattedChildren);
  return (
    <Box
      width="auto"
      onClick={() => navigate(to)}
      style={{ cursor: "pointer" }}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Label color={colors.dark} hoverColor={colors.primary}>
          {children}
        </Label>
        {selected && <Box width="5px" height="5px" backgroundColor={colors.primary} style={{ borderRadius: '100px' }} />}
      </Flex>
    </Box>
  );
};
